import _ from 'lodash'

export default {
  SET_STATE: (state, payload) => {
    _.set(state, payload.action, payload.data)
  },
  SET_STATUS(state, { id, status, type }) {
    const record = state.records.find((rec) => rec._id === id)
    if (record) {
      if (type == 'is_active') {
        record.is_active = status
      }
      if (type == 'is_featured') {
        record.is_featured = status
      }
    }
  }
}
